// extracted by mini-css-extract-plugin
export default {"photoContainer":"styles_photoContainer__3rutC","sender":"styles_sender__51Pfq","hour":"styles_hour__2n8F6"};